import { useTranslations } from 'next-intl';

/**
 * Shared component to display when no message is found in the inbox.
 * @returns the no message found component
 */
function InboxNoMessageFound() {
  const t = useTranslations('my_account.inbox');

  return (
    <div className="flex items-top md:items-center justify-center md:min-h-50">
      <div className="text-center">
        <h3 className="mb-2">{t('error.title')}</h3>
        <p className="text-muted-foreground">{t('error.description')}</p>
      </div>
    </div>
  );
}

export { InboxNoMessageFound };
